import app from '~/app';
import wishlistPage from '~/js/components/wishlist-page';
import wishlistSharePopup from '~/js/components/wishlist-share-popup';

app.add({
  'wishlist-page': wishlistPage,
  'wishlist-share-popup': wishlistSharePopup,
});

app.mount();
